// extracted by mini-css-extract-plugin
module.exports = {"Closing":"PressReleases_Closing__2nce7","ImageContainer":"PressReleases_ImageContainer__1WiNJ"};